import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import WOW from "wowjs";

const Animation = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        const WOWClass = WOW && WOW.WOW ? WOW.WOW : WOW;
        if (WOWClass) {
          const wow = new WOWClass({
            boxClass: "wow",
            animateClass: "animated",
            offset: 30,
            mobile: true,
            live: true,
            scrollContainer: null,
            resetAnimation: false
          });
          wow.init();

          // Safety reveal fallback for any dynamic React content
          const revealStuckElements = () => {
            if (typeof document !== "undefined") {
              document.querySelectorAll('.wow').forEach(el => {
                el.style.visibility = 'visible';
              });
            }
          };

          const t1 = setTimeout(() => { if (typeof wow.sync === "function") wow.sync(); revealStuckElements(); }, 150);
          const t2 = setTimeout(() => { if (typeof wow.sync === "function") wow.sync(); revealStuckElements(); }, 600);
          const t3 = setTimeout(() => { revealStuckElements(); }, 1200);

          return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
          };
        }
      }
    } catch (err) {
      console.warn("WOW.js initialization notice:", err);
    }
  }, [location.pathname, location.search]);

  return null;
};

export default Animation;

